import { ACCOUNT_FEATURES, CLOUD_TYPE_IDS } from 'users/constants/usersConstants';
import { AwsCommonFields, K8S_CUE_FIELDS } from 'shared/constants/awsConstants';
import { GcpCommonFields } from 'shared/constants/gcpConstants';
import { AzureCommonFields } from 'shared/constants/azureConstants';
import { PageNames } from 'shared/constants/appConstants';

export const getBudgetFiltersArrByCloudType = (cloudType) => {
  const filters = {
    [CLOUD_TYPE_IDS.AWS]: [
      AwsCommonFields.CHARGE_TYPE,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.REGION,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.SERVICE,
      AwsCommonFields.QUANTITY_TYPE,
      AwsCommonFields.SUB_SERVICE,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.OPERATION,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.AVAILABILITY_ZONE,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.GOVERNANCE_TAGS_KEYS,
    ],
    [CLOUD_TYPE_IDS.GCP]: [
      AzureCommonFields.DIVISION,
      AzureCommonFields.COST_CENTER,
      AzureCommonFields.SUBSCRIPTION_ID,
      AzureCommonFields.SERVICE,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.REGION,
      GcpCommonFields.CUSTOM_TAGS,
      GcpCommonFields.COST_TYPE_DESCRIPTION,
      AwsCommonFields.RESOURCE,
    ],
    [CLOUD_TYPE_IDS.AZURE]: [
      AzureCommonFields.DIVISION,
      AzureCommonFields.COST_CENTER,
      AzureCommonFields.SUBSCRIPTION_ID,
      AzureCommonFields.REGION,
      AzureCommonFields.SERVICE,
      AzureCommonFields.METER_MAME,
      AzureCommonFields.METER_CATEGORY,
      AzureCommonFields.SUB_METER_CATEGORY,
      AzureCommonFields.CUSTOM_TAGS,
      AzureCommonFields.BUSINESS_MAPPING,
      AzureCommonFields.PURCHASE_OPTION,
      AzureCommonFields.USAGE_TYPE,
      AzureCommonFields.RESOURCE_GROUP,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.ACCOUNT_TAGS,
      AzureCommonFields.VIRTUAL_CUSTOM_TAGS,
    ],
    [CLOUD_TYPE_IDS.MULTI]: [
      AwsCommonFields.COST_TYPE,
      AwsCommonFields.CLOUD_PROVIDER,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.SERVICE,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.OPERATION,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.REGION,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.CATEGORIES,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
    ],
  };
  return filters[cloudType] || [];
};

export const getAlertsFiltersByCloudType = (cloudType) => {
  const baseFilters = [
    AwsCommonFields.SERVICE,
    AwsCommonFields.LINKED_ACCOUNT_ID,
    AwsCommonFields.FAMILY_TYPE,
    AwsCommonFields.DIVISION,
    AwsCommonFields.COST_CENTER,
    AwsCommonFields.CHARGE_TYPE,
    // AwsCommonFields.BUSINESS_MAPPING,
    AwsCommonFields.ACCOUNT_TAGS,
    AwsCommonFields.USAGE_TYPE,
    AwsCommonFields.OPERATION,
    AwsCommonFields.PURCHASE_OPTION,
  ];
  const alertsFilters = {
    [CLOUD_TYPE_IDS.AWS]: [...baseFilters, AwsCommonFields.CUSTOM_TAGS],
    [CLOUD_TYPE_IDS.GCP]: baseFilters,
    [CLOUD_TYPE_IDS.AZURE]: [...baseFilters, AwsCommonFields.CUSTOM_TAGS],
  };
  return alertsFilters[cloudType] || [];
};
const getMetricsFiltersArrByCloudType = (cloudType) => {
  const filters = {
    [CLOUD_TYPE_IDS.AWS]: [AwsCommonFields.LINKED_ACCOUNT_ID, AwsCommonFields.INSTANCE_TYPE, AwsCommonFields.RESOURCE],
  };
  return filters[cloudType] || [];
};
const getCueFiltersArrByCloudType = (cloudType, currentDisplayedAccountFeatures) => {
  const filters = {
    [CLOUD_TYPE_IDS.MULTI]: [
      AwsCommonFields.CLOUD_PROVIDER,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.REGION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.SERVICE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.CATEGORIES,
    ],
    [CLOUD_TYPE_IDS.AWS]: [
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.REGION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.SERVICE,
      AwsCommonFields.SUB_SERVICE,
      AwsCommonFields.CHARGE_TYPE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.AVAILABILITY_ZONE,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.CATEGORIES,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.QUANTITY_TYPE,
      AwsCommonFields.DB_ENGINE,
      AwsCommonFields.PLATFORM,
      AwsCommonFields.NORMALIZATION_FACTOR,
      AwsCommonFields.BILLING_ENTITY,
      AwsCommonFields.LEGAL_ENTITY,
      AwsCommonFields.PAYMENT_OPTION,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.COST_CATEGORY,
      AwsCommonFields.TAX_TYPE,
      AwsCommonFields.INVOICE_ID,
      AwsCommonFields.PRODUCT_NAME,
      AwsCommonFields.BILL_TYPE,
      AwsCommonFields.INSTANCE_TYPE_FAMILY,
    ],
    [CLOUD_TYPE_IDS.GCP]: [
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.PROJECT,
      AwsCommonFields.REGION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.SERVICE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.RESOURCE,
      GcpCommonFields.COST_TYPE_DESCRIPTION,
      GcpCommonFields.CUSTOM_TAGS,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.CATEGORIES,
    ],
    [CLOUD_TYPE_IDS.AZURE]: [
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AzureCommonFields.SUBSCRIPTION_ID,
      AzureCommonFields.RESOURCE_GROUP,
      AzureCommonFields.SERVICE_CATEGORY,
      AwsCommonFields.SERVICE,
      AwsCommonFields.REGION,
      AzureCommonFields.METER_CATEGORY,
      AwsCommonFields.OPERATION,
      AzureCommonFields.SUB_METER_CATEGORY,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.QUANTITY_TYPE,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.BUSINESS_MAPPING,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.CATEGORIES,
      AzureCommonFields.BENEFIT,
      AzureCommonFields.PUBLISHER_NAME,
      AzureCommonFields.PUBLISHER_CATEGORY,
      AzureCommonFields.CHARGE_CATEGORY,
      AzureCommonFields.PARTNER_CREDIT_RATE,
      AzureCommonFields.AZURE_COST_CENTER,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
    ],
  };
  if (currentDisplayedAccountFeatures?.includes?.(ACCOUNT_FEATURES.GOVERNANCE_TAGS)) {
    Object.values(filters).forEach((filterArr) => {
      const idx = filterArr.indexOf(AwsCommonFields.ACCOUNT_TAGS);
      const insertIndex = idx !== -1 ? idx + 1 : filterArr.length;
      filterArr.splice(insertIndex, 0, AwsCommonFields.GOVERNANCE_TAGS_KEYS);
    });
  }
  return filters[cloudType] || [];
};
const getCueCategoriesFiltersArrByCloudType = (cloudType) => {
  const filters = {
    [CLOUD_TYPE_IDS.AWS]: [
      AwsCommonFields.REGION,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.SERVICE,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.OPERATION,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.SUB_SERVICE,
      AwsCommonFields.CHARGE_TYPE,
      AwsCommonFields.AVAILABILITY_ZONE,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.CATEGORIES,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.ITEM_DESCRIPTION,
      AwsCommonFields.NORMALIZATION_FACTOR,
      AwsCommonFields.COST_CATEGORY,
      AwsCommonFields.TAX_TYPE,
      AwsCommonFields.PLATFORM,
      AwsCommonFields.DB_ENGINE,
      AwsCommonFields.BILLING_ENTITY,
      AwsCommonFields.LEGAL_ENTITY,
      AwsCommonFields.INSTANCE_TYPE_FAMILY,
      AwsCommonFields.PAYMENT_OPTION,
      AwsCommonFields.GOVERNANCE_TAGS_KEYS,
    ],
    [CLOUD_TYPE_IDS.GCP]: [
      AwsCommonFields.REGION,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.SERVICE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      GcpCommonFields.COST_TYPE_DESCRIPTION,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.CATEGORIES,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.ITEM_DESCRIPTION,
    ],
    [CLOUD_TYPE_IDS.AZURE]: [
      AzureCommonFields.SUBSCRIPTION_ID,
      AzureCommonFields.RESOURCE_GROUP,
      AzureCommonFields.METER_CATEGORY,
      AzureCommonFields.SUB_METER_CATEGORY,
      AwsCommonFields.REGION,
      AwsCommonFields.SERVICE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.PAYER_ACCOUNT,
      AzureCommonFields.BENEFIT,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.CATEGORIES,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.ITEM_DESCRIPTION,
      AzureCommonFields.PARTNER_CREDIT_RATE,
      AzureCommonFields.CHARGE_CATEGORY,
      AzureCommonFields.PUBLISHER_CATEGORY,
      AzureCommonFields.PUBLISHER_NAME,
      AzureCommonFields.AZURE_COST_CENTER,
      AzureCommonFields.SERVICE_CATEGORY,
    ],
    [CLOUD_TYPE_IDS.MULTI]: [
      AwsCommonFields.CLOUD_PROVIDER,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.SERVICE,
      AwsCommonFields.DIVISION,
      AwsCommonFields.COST_CENTER,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.OPERATION,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.REGION,
      AwsCommonFields.CATEGORIES,
      AwsCommonFields.RESOURCE,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.VIRTUAL_CUSTOM_TAGS,
    ],
  };
  return filters[cloudType] || [];
};
export const getK8SFiltersArrByCloudType = (cloudType, features, onlyK8S = false) => {
  const filters = {
    [CLOUD_TYPE_IDS.AWS]: [
      AwsCommonFields.CLUSTER,
      AwsCommonFields.NODE,
      AwsCommonFields.POD,
      AwsCommonFields.NODE_GROUP,
      AwsCommonFields.WORKLOAD_TYPE,
      AwsCommonFields.WORKLOAD,
      AwsCommonFields.NAMESPACE,
      AwsCommonFields.K8S_LABEL_TAGS,
    ],
    [CLOUD_TYPE_IDS.AZURE]: [
      AzureCommonFields.CLUSTER,
      AzureCommonFields.NODE,
      AwsCommonFields.POD,
      AzureCommonFields.NODE_GROUP,
      AzureCommonFields.WORKLOAD_TYPE,
      AwsCommonFields.WORKLOAD,
      AzureCommonFields.NAMESPACE,
      AzureCommonFields.K8S_LABEL_TAGS,
    ],
    [CLOUD_TYPE_IDS.GCP]: [
      GcpCommonFields.CLUSTER,
      AwsCommonFields.POD,
      GcpCommonFields.NODE_GROUP,
      GcpCommonFields.NAMESPACE,
      GcpCommonFields.K8S_REGION,
      GcpCommonFields.K8S_LABEL_TAGS,
    ],
  };
  const generalFilters = {
    [CLOUD_TYPE_IDS.AWS]: [
      AwsCommonFields.K8S_REGION,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.K8S_INSTANCE_TYPE,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.BUSINESS_MAPPING,
    ],
    [CLOUD_TYPE_IDS.AZURE]: [
      AzureCommonFields.K8S_REGION,
      AzureCommonFields.SUBSCRIPTION_ID,
      AwsCommonFields.ACCOUNT_TAGS,
      AwsCommonFields.K8S_INSTANCE_TYPE,
      AzureCommonFields.BUSINESS_MAPPING,
    ],
    [CLOUD_TYPE_IDS.GCP]: [
      GcpCommonFields.LINKED_ACCOUNT_ID,
      GcpCommonFields.PAYER_ACCOUNT,
      AwsCommonFields.K8S_INSTANCE_TYPE,
      GcpCommonFields.CUSTOM_TAGS,
      GcpCommonFields.SUB_VIEWS_CUSTOM_TAGS,
      AwsCommonFields.ACCOUNT_TAGS,
      GcpCommonFields.BUSINESS_MAPPING,
    ],
  };
  return [
    ...(filters[cloudType] || []),
    ...(onlyK8S
      ? [AwsCommonFields.K8S_RESOURCE_TYPE, AwsCommonFields.K8S_ALLOCATION_STATUS]
      : generalFilters[cloudType] || []),
  ];
};
const getCueBusinessMappingsFiltersArrByCloudType = (cloudType) => {
  const categoriesFilters = getCueCategoriesFiltersArrByCloudType(cloudType);
  return categoriesFilters.filter((c) => ![AwsCommonFields.CATEGORIES].includes(c) && !K8S_CUE_FIELDS.includes(c));
};
const getCueBusinessMappingsUnifiedFiltersArrByCloudType = (cloudType) => {
  const categoriesFilters = getCueCategoriesFiltersArrByCloudType(cloudType);
  const k8sFields = getK8SFiltersArrByCloudType(cloudType, null, true);
  return [
    ...categoriesFilters.filter((c) => ![AwsCommonFields.CATEGORIES].includes(c) && !K8S_CUE_FIELDS.includes(c)),
    ...k8sFields,
  ];
};
const getK8SBusinessMappingsFiltersArrByCloudType = (cloudType) => {
  const k8sFilters = getK8SFiltersArrByCloudType(cloudType);
  return k8sFilters.filter((c) => ![AwsCommonFields.BUSINESS_MAPPING].includes(c));
};
const getCueDashboardFiltersArrByCloudType = (cloudType) => {
  const categoriesFilters = getCueCategoriesFiltersArrByCloudType(cloudType);
  return [...categoriesFilters, AwsCommonFields.BUSINESS_MAPPING];
};
export const getBillingRuleFiltersByCloudType = (cloudType) =>
  ({
    [CLOUD_TYPE_IDS.AWS]: [
      AwsCommonFields.SERVICE,
      AwsCommonFields.REGION,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.QUANTITY_TYPE,
      AwsCommonFields.CHARGE_TYPE,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.COST_TYPE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.ITEM_DESCRIPTION,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.CLOUD_FRONT_REGION,
    ],
    [CLOUD_TYPE_IDS.AZURE]: [
      AwsCommonFields.SERVICE,
      AwsCommonFields.REGION,
      AwsCommonFields.USAGE_TYPE,
      AwsCommonFields.PURCHASE_OPTION,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.QUANTITY_TYPE,
      AzureCommonFields.METER_MAME,
      AzureCommonFields.METER_CATEGORY,
      AzureCommonFields.SUB_METER_CATEGORY,
      AzureCommonFields.SUBSCRIPTION_ID,
      AwsCommonFields.COST_TYPE,
    ],
    [CLOUD_TYPE_IDS.GCP]: [
      AzureCommonFields.SERVICE,
      AwsCommonFields.REGION,
      AwsCommonFields.CUSTOM_TAGS,
      AwsCommonFields.FAMILY_TYPE,
      AwsCommonFields.COST_TYPE,
      AwsCommonFields.OPERATION,
      AwsCommonFields.INSTANCE_TYPE,
      GcpCommonFields.COST_TYPE_DESCRIPTION,
      AwsCommonFields.LINKED_ACCOUNT_ID,
    ],
  }[cloudType] || []);

export const mapPageNameToFiltersList = new Map([
  [PageNames.COST_AND_USAGE_EXPLORER, getCueFiltersArrByCloudType],
  [PageNames.METRICS_EXPLORER, getMetricsFiltersArrByCloudType],
  [PageNames.FILTER_GROUP, getCueCategoriesFiltersArrByCloudType],
  [PageNames.BUSINESS_MAPPING, getCueBusinessMappingsFiltersArrByCloudType],
  [PageNames.BUSINESS_MAPPING_UNIFIED, getCueBusinessMappingsUnifiedFiltersArrByCloudType],
  [PageNames.BUSINESS_MAPPING_K8S, getK8SBusinessMappingsFiltersArrByCloudType],
  [PageNames.CUSTOM_DASHBOARD, getCueDashboardFiltersArrByCloudType],
  [PageNames.CUE_ALERTS, getAlertsFiltersByCloudType],
  [
    PageNames.EC2_USAGE,
    () => [
      AwsCommonFields.REGION,
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.LINKED_ACCOUNT_ID,
      AwsCommonFields.OS,
    ],
  ],
  [
    PageNames.SAVINGS_PLANS_ANALYZER,
    () => [
      // AwsCommonFields.OS, // TODO - uncomment once we will support OS filter
      // AwsCommonFields.ENVIRONMENT,
      // AwsCommonFields.PROJECT,
      // AwsCommonFields.SERVICE, // TODO - uncomment once we will support service filter
      AwsCommonFields.INSTANCE_TYPE,
      AwsCommonFields.LINKED_ACCOUNT_ID,
    ],
  ],
  [PageNames.BUDGET, getBudgetFiltersArrByCloudType],
  [PageNames.AWS_RESELLER, () => [AwsCommonFields.SERVICE, AwsCommonFields.OPERATION, AwsCommonFields.REGION]],
  [PageNames.RECOMMENDATIONS_REPORTS, () => [AwsCommonFields.LINKED_ACCOUNT_NAME, AwsCommonFields.DIVISION]],
  [PageNames.CUSTOMERS_REPORTS, () => [AwsCommonFields.DIVISION]],
  [
    PageNames.RECOMMENDATION_DASHBOARD,
    () => [AwsCommonFields.LINKED_ACCOUNT_ID, AwsCommonFields.ACCOUNT_TAGS, AwsCommonFields.REC_DB_CUSTOM_TAGS],
  ],
  [PageNames.ANOMALY_DETECTION, () => [AwsCommonFields.LINKED_ACCOUNT_ID, AwsCommonFields.SERVICE]],
  [PageNames.IDLE_INSTANCES, () => [AwsCommonFields.LINKED_ACCOUNT_ID]],
  [PageNames.EBS_USAGE, () => [AwsCommonFields.LINKED_ACCOUNT_NAME]],
  [PageNames.RI_UTILIZATION, () => [AwsCommonFields.LINKED_ACCOUNT_ID, AwsCommonFields.PAYER_ACCOUNT]],
  // removed pods filter - too heavy for the browser, > 2M pods
  [PageNames.K8S_USAGE, getK8SFiltersArrByCloudType],
  [PageNames.CUE_K8S, (cloudType) => getK8SFiltersArrByCloudType(cloudType, null, true)],
  [PageNames.BILLING_RULES_NEW, getBillingRuleFiltersByCloudType],
]);

export const filterTooltips = new Map([[AwsCommonFields.VIRTUAL_CUSTOM_TAGS, "Formerly known as 'Virtual Tags'"]]);
